import { ErrorBoundary } from "react-error-boundary";
import { ReactNode } from "react";
import { Box, Paper, Typography } from "@mui/material";
import { PageFrame } from "../page_frame";

export const AppErrorFallback = () => {
  return (
    <PageFrame>
      <Box
        sx={{
          height: "100%",
        }}
      >
        <Paper
          sx={{
            height: "98%",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            backgroundColor: "action.hover",
            borderRadius: 1,
          }}
        >
          <Typography variant="h1" sx={{ mb: 2 }}>
            Oups! Something went wrong.
          </Typography>
          <Typography>
            Please refresh the page. If error persists, please contact support.
          </Typography>
        </Paper>
      </Box>
    </PageFrame>
  );
};

export const AppErrorBoundary = ({ children }: { children: ReactNode }) => {
  return (
    <ErrorBoundary FallbackComponent={AppErrorFallback}>
      {children}
    </ErrorBoundary>
  );
};
